import { useContext } from "react";
import useSWR from "swr";
import { UserContext } from "Contexts/UserContext/UserContext";
import { useServicesContext } from "Contexts/ServicesContext/ServicesContext";
import GetShoppingCart, { getUserShoppingCartQuery } from "./cartRequests";

const initialCart = {
  shoppingCartId: 0,
  itemCount: 0,
};

const useCart = () => {
  const services = useServicesContext();
  const { context: userContext } = useContext(UserContext);

  const checkoutUrl = services?.checkout?.url

  const isHydrated = userContext?.hydrated;
  const webUserGuid = userContext?.getGuid();
  const isBot = userContext?.isBot();
  const cacheKey = isHydrated && !isBot ? [getUserShoppingCartQuery, webUserGuid] : null;

  const { data: cart, mutate, error } = useSWR(
    cacheKey,
    (_, webUserGuid) => GetShoppingCart(checkoutUrl, webUserGuid),
    { fallbackData: initialCart }
  );

  const updateCart = () => mutate();

  return {
    updateCart,
    cart,
  };
};

export default useCart;
